module.exports = __webpack_public_path__ + "static/media/dodo.d644da1b.svg";